var exports = {
  "k": "VoiceParticipantsList.module__container___UDNien",
};

module.exports = exports;
